import Head from 'next/head';
import { AppProps } from 'next/app';
import { FunctionComponent, useEffect, useState } from 'react';

import '../styles/globals.sass';
import PageTemplate from '../components/sharedMods/PageTemplate';
import { Request } from '../utils/request';
import { SentryMonitor } from '../utils/sentry';

import { DashboardStoreContext } from '../model/context/dashboard.context';
import { HomePageStoreContext } from '../model/context/home-page.context';
import { HomePageRootStore } from '../model/store/index.store';
import { DashboardRootStore } from '../model/store/dashboard.store';
import GlobalNotificationProvider from '../components/providers/GlobalNotificationProvider';
import { BrowserEnv } from '../utils/types/env.types';
import { useBrowserEnv } from '../utils/env';

// Initialize the app
// SentryMonitor.init();
Request.init();

// Decide which template to use
const NAV_BAR_PATH_NAMES = [
    '/b2b2c/business/income',
    '/b2b2c/business/return',
    '/b2b2c/business',
    '/b2b2c/about',
    '/b2b2c',
];

const DASHBOARD_TEMPL_PATH_NAMES = ['/dashboard'];

const RETURN_PORTAL_PATHS = ['/return/portal'];

const CustomApp: FunctionComponent<AppProps> = ({ Component, router, pageProps }) => {
    const env = useBrowserEnv();

    const { pathname } = router;
    console.log('test-log', env, pathname);

    if (NAV_BAR_PATH_NAMES.includes(pathname)) {
        return (
            <>
                <Head>
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1, shrink-to-fit=no"
                    />
                    <script
                        type="text/javascript"
                        id="hs-script-loader"
                        async
                        defer
                        src="//js.hs-scripts.com/7597086.js"
                    />
                </Head>
                <HomePageStoreContext.Provider value={new HomePageRootStore()}>
                    <PageTemplate>
                        <Component {...pageProps} />
                    </PageTemplate>
                </HomePageStoreContext.Provider>
            </>
        );
    }

    if (DASHBOARD_TEMPL_PATH_NAMES.includes(pathname)) {
        return (
            <>
                <Head>
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1, shrink-to-fit=no"
                    />
                </Head>
                {env === BrowserEnv.Server ? null : (
                    <DashboardStoreContext.Provider value={new DashboardRootStore()}>
                        <GlobalNotificationProvider>
                            <Component {...pageProps} />
                        </GlobalNotificationProvider>
                    </DashboardStoreContext.Provider>
                )}
            </>
        );
    }

    if (RETURN_PORTAL_PATHS.includes(pathname)) {
        return (
            <>
                <Head>{/* Use desktop viewport for all pages */}</Head>
                {env === BrowserEnv.Browser ? <Component {...pageProps} /> : null}
            </>
        );
    }

    return (
        <>
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, shrink-to-fit=no"
                />
            </Head>
            <Component {...pageProps} />
        </>
    );
};

export default CustomApp;
